module.exports = __webpack_public_path__ + "static/media/Gaspar_Bold.cdb296bb.ttf";